import { FontWeight, Heading } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { Icons, Icon } from '@Components/icon/Icon';
import { OptionStrip } from '@Components/OptionStrip';
import { useNavigationManager } from '@Router/useNavigationManager';
import { RoutesMap } from '@Router/router.types';

export const RecoveryRoot = () => {
  const { navigateToNextPage } = useNavigationManager();
  const { t } = useTranslation();
  return (
    <div className='recovery-page-container'>
      <div className='flex flex-col items-center'>
        <Icon icon={Icons.Shield} className='w-[90px] mb-[40px]' />
        <Heading.H3 fontWeight={FontWeight.MEDIUM} className='recovery-page-header'>
          {t('recovery.root.title')}
        </Heading.H3>
        <Heading.H9
          fontWeight={FontWeight.REGULAR}
          className='text-text-main-secondary w-[380px] text-center mb-[24px]'>
          {t('recovery.root.subtitle')}
        </Heading.H9>
        <div className='w-[500px]'>
          <OptionStrip
            icon={<Icon icon={Icons.Fingerprint} className='w-fit mr-[8px]' />}
            title={t('recovery.root.forgotPasswordOption')}
            onClick={() => navigateToNextPage(RoutesMap.RECOVERY)}
          />
        </div>
      </div>
    </div>
  );
};
